import { createApp } from "vue";
import DataWebConfig from "@PrivateArea/Scripts/Config/DataWebConfig";
import { router } from "@PrivateArea/Scripts/Config/RouteConfig";
import { store } from "@PrivateArea/Scripts/Config/StoreConfig";

export default class DataWebPage {
    public static async init() {
        let DataWeb = (<any>window).DataWeb;
        if (DataWeb) {
            const app = createApp({});
            (<any>app).config.devtools = false;

            app.use(DataWeb.default);
            app.use(DataWebConfig);

            DataWeb.default.registerRoutes(router);
            DataWeb.default.registerStoreModules(store);

            await DataWeb.Localizer.init({ defaultCulture: (<any>window).App.userCulture, resourceContexts: ["DataWeb", "Account"] });

            app.use(router).use(store);

            (<any>window).App.instances.vm = app.mount('#app');
        }
    }
}